import MNavigationDrawer from './MNavigationDrawer.vue';

export { MNavigationDrawer };
export default MNavigationDrawer;
